import { BOT_VALUES } from '@/api/consts'
import type { Bot } from '@/api/schema'

export function getBotStorageKey(bot: Bot) {
  switch (bot) {
    case 'milana':
      return 'messages_milana'
    case 'eva':
      return 'messages_eva'
    default:
      return 'messages'
  }
}

export function hasChatHistory() {
  return BOT_VALUES.some(bot => {
    const rawMessages = localStorage.getItem(getBotStorageKey(bot))

    if (!rawMessages) return false

    try {
      const messages = JSON.parse(rawMessages)

      return Array.isArray(messages) && messages.length > 0
    }
    catch {
      return true
    }
  })
}
